import axios from 'axios'
import store from '@/store'

/* const api2 = axios.create({
  //baseURL: process.env.VUE_APP_API_URL,
  baseURL: 'http://localhost:8000',
  headers: {
    //'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
}) */

const api = axios.create({
  // Use empty string for relative URLs (goes through nginx proxy)
  baseURL: '',
  //baseURL: 'https://signature-checker2.etsi.org',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json'
   
  },
})


api.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
   
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
    async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await store.dispatch('auth/refreshToken')
        return api(originalRequest)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  }
)

export default api


